import { render, staticRenderFns } from "./ExportRequestsAdmin.vue?vue&type=template&id=81a6b962&scoped=true"
import script from "./ExportRequestsAdmin.vue?vue&type=script&lang=js"
export * from "./ExportRequestsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a6b962",
  null
  
)

export default component.exports